<template>
  <button class="button flex items-center justify-center" :class="{
    [type]: true,
    disabled: disabled,
    warning: warning,
    success: !disabled && !warning,
  }" :disabled="disabled" :readonly="readonly">
    <slot />
  </button>
</template>

<script setup lang="ts">

interface Props {
  type: 'vip' | 'long' | 'medium' | 'small' | 'back' | 'close' | 'record' | 'next' | 'default'
  warning?: boolean
  disabled?: boolean
  readonly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  type: 'medium',
  disabled: false,
  warning: false,
  readonly: false
})



</script>

<style lang="scss" scoped>
.button {
  margin: 5px 0 !important;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  padding: 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.vip {
    height: 29px;
    width: 84px;
    font-size: 9px;
    font-weight: bold;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    

    &.disabled {
      color: #E2E2E2;
      background-image: getPath('button/vip-disabled.png');
    }

    &.warning {
      color: #FFFEE0;
      background-image: getPath('button/vip-warning.png');
    }

    &.success {
      color: #FFFEE0;
      background-image: getPath('button/vip-success.png');
    }
  }

  &.long {
    height: 32px;
    width: 253px;
    font-size: 13px;
    font-weight: bold;
    background-repeat: no-repeat;
    background-size: 100% calc(100% + 1px);

    &.disabled {
      color: #E2E2E2;
      background-image: getPath('button/long-disabled.png');
    }

    &.warning {
      color: #FFFFFF;
      background-image: getPath('button/long-warning.png');
    }

    &.success {
      color: #FFFFFF;
      background-image: getPath('button/long-success.png');
    }
  }

  &.medium {
    height: 40px;
    width: 148px;
    font-size: 14px;
    font-weight: bold;
    background-repeat: no-repeat;
    background-size: 100% calc(100% + 1px);

    &.disabled {
      color: #E2E2E2;
      background-image: getPath('button/medium-disabled.png');
    }

    &.warning {
      color: #FFFFFF;
      background-image: getPath('button/medium-warning.png');
    }

    &.success {
      color: #FFFFFF;
      background-image: getPath('button/medium-success.png');
    }
  }

  &.default {
    height: 40px;
    width: 148px;
    font-size: 14px;
    font-weight: bold;
    background-repeat: no-repeat;
    background-size: 100% calc(100% + 1px);

    &.disabled {
      color: #E2E2E2;
      background-image: getPath('button/default-disabled.png');
    }

    &.warning {
      color: #FFFFFF;
      background-image: getPath('button/default-warning.png');
    }

    &.success {
      color: #FFFFFF;
      background-image: getPath('button/default-success.png');
    }
  }

  &.small {
    height: 18px;
    width: 52px;
    font-size: 10px;
    font-weight: bold;
    background-repeat: no-repeat;
    background-size: 100% calc(100% + 1px);

    &.disabled {
      color: #E2E2E2;
      background-image: getPath('button/small-disabled.png');
    }

    &.warning {
      color: #FFFFFF;
      background-image: getPath('button/small-warning.png');
    }

    &.success {
      color: #FFFFFF;
      background-image: getPath('button/small-success.png');
    }
  }

  &.back {
    height: 38px;
    width: 38px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    &.disabled {
      background-image: getPath('button/back-disabled.png');
    }

    &.warning {
      background-image: getPath('button/back-warning.png');
    }

    &.success {
      background-image: getPath('button/back-success.png');
    }
  }

  &.close {
    height: 38px;
    width: 38px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    &.disabled {
      background-image: getPath('button/close-disabled.png');
    }

    &.warning {
      background-image: getPath('button/close-warning.png');
    }

    &.success {
      background-image: getPath('button/close-success.png');
    }
  }

  &.record {
    height: 38px;
    width: 38px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    &.disabled {
      background-image: getPath('button/record-disabled.png');
    }

    &.warning {
      background-image: getPath('button/record-warning.png');
    }

    &.success {
      background-image: getPath('button/record-success.png');
    }
  }

  &.next {
    height: 38px;
    width: 38px;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    &.disabled {
      background-image: getPath('button/next-disabled.png');
    }

    &.warning {
      background-image: getPath('button/next-warning.png');
    }

    &.success {
      background-image: getPath('button/next-success.png');
    }
  }
}
</style>
